export const HOME_ROUTE = '/dashboard'
export const KEYS_ROUTE = '/keys'
export const JOBS_ROUTE = '/jobs'
export const PLAYGROUND_ROUTE = '/playground'
export const SETTINGS_ROUTE = '/settings'
export const AUDIT_ROUTE = '/audit'
